
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { selectPlatformDBAServicesListItems } from "../../../../../../../redux/platform-dba-services/selector";
import { platformDBAServices } from "../../../../../../../redux/platform-dba-services/action";
import PageLoader from "../../../../../../../components/PageLoader";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";



const DBAServices = ({selectedDba}: any) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const platformDBAServicesItems = useSelector(selectPlatformDBAServicesListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true, filterType: 'text' },
      { field: 'DBNIEName', headerName: 'DBNIE Name', searchField: 'DBNIEName', filter: true, filterType: 'text' },
      { field: 'DBNPName', headerName: 'DBNP Name', searchField: 'DBNPName', filter: true, filterType: 'text' },
      { field: 'DBNPRegistryName', headerName: 'DBNP Registry Name', searchField: 'DBNPRegistryName', filter: true, filterType: 'text' },
      { field: 'OrgRegistryName', headerName: 'OrgRegistry Name', searchField: 'OrgRegistryName', filter: true, filterType: 'text' },
      { field: 'DBAName', headerName: 'DBA Name', searchField: 'DBAName', filter: true, filterType: 'text', callback: handleDBA },
       { field: 'IsEnabled', headerName: 'Enabled', cellRenderer: 'yesNoRenderer' },

    ]);
  }

  const handleDBA = async (data: any) => {
    console.log('handleDBA data', data)
    navigate(`/management/dbn-cloud/dbas/${data.DBAId}`)
  }
  

  //   if (Array.isArray(data)) {
  //     return data.filter(Boolean).map((type: string, index: number) => (
  //       <div key={index}>{type}</div>
  //     ));
  //   }
  //   return data ?? '';
  // };
 const fetchServicesList = async (searchCriteria: any = [], filterCriteria: any = [], dateCriteria: any = []) => {
    await dispatch(platformDBAServices.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn-cloud/dba-services/list`,
      entity: 'platformDBAServices',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "isOrCondition": true,
        "isFilterConditionOr": true,
        "isSearchConditionOr": true,
        "Filters": filterCriteria,
        "Searches": searchCriteria,
        "DateCriteria": dateCriteria
      }
      
    
    }))
  }

  useEffect(() => {
    createColumnDefs();
    fetchServicesList();
  }, [pageData, pageSize])


  const handleEdit = (data: any) => {
    navigate(`/management/dbn-cloud/dbas/${selectedDba?.DBAId}/dba-service/${data?.Id}`)
  }

 const additionButtons: any = [
      {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];


  const handleReloadData = () => {
    fetchServicesList();
  }

  const handleSearch = async (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await fetchServicesList(searchCriteria);
  }

  return (
    <>
      {platformDBAServicesItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={platformDBAServicesItems?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          paginationData={platformDBAServicesItems?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Name',
          }} 
          headingName="DBA Services"
        />
      }
    </>
  );
};

export default DBAServices;


